import { jsx as _jsx } from "react/jsx-runtime";
export function Progress({ percent }) {
    return (_jsx("div", { className: "w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700", children: _jsx("div", { className: "bg-blue-600 h-2.5 rounded-full", style: { width: `${percent}%` } }) }));
}
//# sourceMappingURL=Progress.js.map